import { render } from "./AsMenu.vue?vue&type=template&id=59a64ea4&ts=true"
import script from "./AsMenu.vue?vue&type=script&lang=ts"
export * from "./AsMenu.vue?vue&type=script&lang=ts"

import "./AsMenu.vue?vue&type=style&index=0&id=59a64ea4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__